import { Component, OnInit } from '@angular/core';
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MasterService } from "../../Shared/app.Masters.Service";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { IpServiceService } from '../../../app/ip-service.service';
import { EncrDecrService } from "../../AuthGuard/EncrDecrService";
declare var $: any;

@Component({
  selector: 'app-backup',
  templateUrl: './backup.component.html',
  styleUrls: ['./backup.component.scss']
})
export class BackupComponent implements OnInit {
  DbLoginId :any ;
  DbLoginPass :any;
  currentUser: any;
  DocDownload:any;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  showSpinner = false;
  constructor( private EncrDecrService: EncrDecrService,
      private dataSharingService: DataSharingService,
        public snackBar: MatSnackBar,
        private MasterService: MasterService
  ) {}

  ngOnInit(): void {
       this.dataSharingService.HeaderTitle.next("Download DataBase Backup");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  }
  onBackup(){
    $("#BackupModal").modal("show");
    $("#BackupModal").css("z-index", "1050");
  }
  onDBAndDocBackup(){
    $("#BackupDBDocModal").modal("show");
    $("#BackupDBDocModal").css("z-index", "1050");
  }
OnClose(){
  $("#BackupModal").modal("hide");
  $("#BackupDBDocModal").modal("hide");

  
}
onDbAndDocBackup(){
  this.showSpinner = true;
   var IPAddress ="";
   
    var currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    var DBLoginID =this.DbLoginId;
     var DBPassword =this.EncrDecrService.encrypt1(this.DbLoginPass);
     var loginUserId=currentUser.userId;
if(this.DocDownload){
    this.MasterService.CreateAndDownloadDBAndDocBackup({DBLoginID:DBLoginID,DBPassword:DBPassword,loginUserId:loginUserId,IPAddress:IPAddress}).subscribe({
      next: (blob) => {
        if (blob) {
          const hostname = window.location.hostname; // e.g., "demo.finnaux.com"
          const parts = hostname.split('.');
          const fileName = parts[0]+`_SQLAndDB_Backup_${new Date().toISOString().slice(0, 19).replace(/[:T]/g, '_')}.zip`;
        
            const a = document.createElement('a');
            const objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = fileName;
            a.click();
            this.showSpinner = false;
            URL.revokeObjectURL(objectUrl);
        }
      },
      error: (err) => {
        console.error('Backup failed:', err);
        if (err.status ==406)
        {
           // alert('Invalid login credentials.');
             this.snackBar.openFromComponent(SnackbarComponent, {
              data: 'Invalid login credentials.',
                ...this.configSuccess,
      });
            this.showSpinner = false;
        }else{
           this.showSpinner = false;
            this.snackBar.openFromComponent(SnackbarComponent, {
            data: 'Backup failed. See console for details.',
             ...this.configSuccess,
      });
          // alert('Backup failed. See console for details.');
        }
      }
   // });
  })
}
else{
  this.onBackupSubmit(); 
}
}
  onBackupSubmit() {
    this.showSpinner = true;
   var IPAddress ="";
  
    var currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    var DBLoginID =this.DbLoginId;
     var DBPassword =this.EncrDecrService.encrypt1(this.DbLoginPass);
     var loginUserId=currentUser.userId;

    this.MasterService.createAndDownloadBackup({DBLoginID:DBLoginID,DBPassword:DBPassword,loginUserId:loginUserId,IPAddress:IPAddress}).subscribe({
      next: (blob) => {
        if (blob) {
          const hostname = window.location.hostname; // e.g., "demo.finnaux.com"
          const parts = hostname.split('.');
          const fileName = parts[0]+`_SQL_Backup_${new Date().toISOString().slice(0, 19).replace(/[:T]/g, '_')}.zip`;
        
            const a = document.createElement('a');
            const objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = fileName;
            a.click();
            this.showSpinner = false;
            URL.revokeObjectURL(objectUrl);
        }
      },
      error: (err) => {
        console.error('Backup failed:', err);
        if (err.status ==406)
        {
           // alert('Invalid login credentials.');
             this.snackBar.openFromComponent(SnackbarComponent, {
              data: 'Invalid login credentials.',
                ...this.configSuccess,
      });
            this.showSpinner = false;
        }else{
           this.showSpinner = false;
            this.snackBar.openFromComponent(SnackbarComponent, {
            data: 'Backup failed. See console for details.',
             ...this.configSuccess,
      });
          // alert('Backup failed. See console for details.');
        }
      }
   // });
  })
  }
}
